/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Project } from './Project';
import {
    ProjectFromJSON,
    ProjectFromJSONTyped,
    ProjectToJSON,
    ProjectToJSONTyped,
} from './Project';
import type { UnitType } from './UnitType';
import {
    UnitTypeFromJSON,
    UnitTypeFromJSONTyped,
    UnitTypeToJSON,
    UnitTypeToJSONTyped,
} from './UnitType';
import type { UnitAllOfReservation } from './UnitAllOfReservation';
import {
    UnitAllOfReservationFromJSON,
    UnitAllOfReservationFromJSONTyped,
    UnitAllOfReservationToJSON,
    UnitAllOfReservationToJSONTyped,
} from './UnitAllOfReservation';

/**
 * 
 * @export
 * @interface Unit
 */
export interface Unit {
    /**
     * 
     * @type {string}
     * @memberof Unit
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Unit
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Unit
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Unit
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Unit
     */
    floor: number;
    /**
     * 
     * @type {string}
     * @memberof Unit
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Unit
     */
    livingArea: number;
    /**
     * 
     * @type {number}
     * @memberof Unit
     */
    totalArea: number;
    /**
     * 
     * @type {number}
     * @memberof Unit
     */
    numberOfBalconies: number;
    /**
     * 
     * @type {number}
     * @memberof Unit
     */
    numberOfRooms: number;
    /**
     * 
     * @type {number}
     * @memberof Unit
     */
    numberOfBathrooms: number;
    /**
     * 
     * @type {number}
     * @memberof Unit
     */
    price: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Unit
     */
    photoURLs?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Unit
     */
    status: UnitStatusEnum;
    /**
     * 
     * @type {Project}
     * @memberof Unit
     */
    project: Project;
    /**
     * 
     * @type {UnitType}
     * @memberof Unit
     */
    type?: UnitType;
    /**
     * 
     * @type {UnitAllOfReservation}
     * @memberof Unit
     */
    reservation?: UnitAllOfReservation;
}


/**
 * @export
 */
export const UnitStatusEnum = {
    Available: 'available',
    Reserved: 'reserved',
    Sold: 'sold'
} as const;
export type UnitStatusEnum = typeof UnitStatusEnum[keyof typeof UnitStatusEnum];


/**
 * Check if a given object implements the Unit interface.
 */
export function instanceOfUnit(value: object): value is Unit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('floor' in value) || value['floor'] === undefined) return false;
    if (!('livingArea' in value) || value['livingArea'] === undefined) return false;
    if (!('totalArea' in value) || value['totalArea'] === undefined) return false;
    if (!('numberOfBalconies' in value) || value['numberOfBalconies'] === undefined) return false;
    if (!('numberOfRooms' in value) || value['numberOfRooms'] === undefined) return false;
    if (!('numberOfBathrooms' in value) || value['numberOfBathrooms'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('project' in value) || value['project'] === undefined) return false;
    return true;
}

export function UnitFromJSON(json: any): Unit {
    return UnitFromJSONTyped(json, false);
}

export function UnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): Unit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'name': json['name'],
        'floor': json['floor'],
        'description': json['description'] == null ? undefined : json['description'],
        'livingArea': json['livingArea'],
        'totalArea': json['totalArea'],
        'numberOfBalconies': json['numberOfBalconies'],
        'numberOfRooms': json['numberOfRooms'],
        'numberOfBathrooms': json['numberOfBathrooms'],
        'price': json['price'],
        'photoURLs': json['photoURLs'] == null ? undefined : json['photoURLs'],
        'status': json['status'],
        'project': ProjectFromJSON(json['project']),
        'type': json['type'] == null ? undefined : UnitTypeFromJSON(json['type']),
        'reservation': json['reservation'] == null ? undefined : UnitAllOfReservationFromJSON(json['reservation']),
    };
}

export function UnitToJSON(json: any): Unit {
    return UnitToJSONTyped(json, false);
}

export function UnitToJSONTyped(value?: Unit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'name': value['name'],
        'floor': value['floor'],
        'description': value['description'],
        'livingArea': value['livingArea'],
        'totalArea': value['totalArea'],
        'numberOfBalconies': value['numberOfBalconies'],
        'numberOfRooms': value['numberOfRooms'],
        'numberOfBathrooms': value['numberOfBathrooms'],
        'price': value['price'],
        'photoURLs': value['photoURLs'],
        'status': value['status'],
        'project': ProjectToJSON(value['project']),
        'type': UnitTypeToJSON(value['type']),
        'reservation': UnitAllOfReservationToJSON(value['reservation']),
    };
}

